import { useId, useState, type ReactNode } from 'react';
import { Button, Sheet } from '@elbklar/ui';
import { InteractionForm, type InteractionFormProps } from './InteractionForm';

export interface InteractionSheetProps extends Omit<InteractionFormProps, 'formId' | 'onPendingChange'> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  /** Ein Satz, etwa der vorbelegte Kontext: „Zu Hausverwaltung Elbufer GmbH“. */
  description?: ReactNode;
  /** Verb zuerst: „Notiz speichern“. */
  submitLabel?: string;
}

/**
 * Interaktion anlegen oder bearbeiten: am Handy als Sheet von unten, am
 * Rechner als Dialog. Die Hauptaktion steht im Fuß.
 */
export function InteractionSheet({
  open,
  onOpenChange,
  title,
  description,
  submitLabel = 'Speichern',
  onSuccess,
  ...formProps
}: InteractionSheetProps) {
  const formId = useId();
  const [speichert, setSpeichert] = useState(false);
  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={speichert}>
            Abbrechen
          </Button>
          <Button type="submit" form={formId} variant="primary" loading={speichert}>
            {submitLabel}
          </Button>
        </>
      }
    >
      <InteractionForm
        {...formProps}
        formId={formId}
        onPendingChange={setSpeichert}
        onSuccess={() => {
          onSuccess?.();
          onOpenChange(false);
        }}
      />
    </Sheet>
  );
}
